import classNames from 'classnames'
import { type ReactNode, useState } from 'react'

import { EIcons } from '@/app/types/iconType'
import { Icon } from '@/shared'

import style from './Dropdown.module.scss'

interface IProps {
    children: ReactNode
    title?: string | ReactNode
    className?: string
    childrenStyles?: string
}

export const DropdownComponent = (props: IProps) => {
    const { children, className, title, childrenStyles } = props
    const [isOpen, setIsOpen] = useState<boolean>(false)
    return (
        <button
            className={classNames(style.container, className && className)}
            onClick={() => setIsOpen((o) => !o)}
            onBlur={() => setIsOpen(false)}
        >
            {title && (
                <div>
                    <span>{title}</span>
                </div>
            )}
            {isOpen && <div className={classNames(style.children, childrenStyles && childrenStyles)}>{children}</div>}
            <div className={style.trigger}>
                <Icon iconName={EIcons.AROW} color='#1F3447' />
            </div>
        </button>
    )
}
